export const ISOFILEMANAGMENT = {
  FETCH_MANAGEMENT_LIST: "FETCH_MANAGEMENT_LIST",
  FILE_MANAGEMENT_LIST: "FILE_MANAGEMENT_LIST",
  DELETE_LIST: "DELETE_LIST",
  UPLOAD_LIST: "UPLOAD_LIST",
  FETCH_DOWNLOAD_LIST: "FETCH_DOWNLOAD_LIST",
  DOWNLOAD_LIST: "DOWNLOAD_LIST",
  UPLOAD_FILE: "UPLOAD_FILE",
  ADD_UPLOADED_LIST: "ADD_UPLOADED_LIST",
  DELETE_UPLOADED_LIST: "DELETE_UPLOADED_LIST",
  DELETE_MULTIPLE_LIST: "DELETE_MULTIPLE_LIST",
  LOCAL_SEARCH: "LOCAL_SEARCH",
  CHECK_ALL_CHECKBOX: "CHECK_ALL_CHECKBOX",
  CHECK_SINGLE_CHECKBOX: "CHECK_SINGLE_CHECKBOX",
  SORTING_ORDER: "SORTING_ORDER",
  SEARCH_VALUE: "SEARCH_VALUE",
  UPLOAD_LOADER:"UPLOAD_LOADER",
  PAGE_DETAILS:"PAGE_DETAILS",
  CANCEL_ISO_UPLOAD:"CANCEL_ISO_UPLOAD",
};
